import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2788_20035)">
      <path
        d="M6.71796 11.6987C6.88628 11.8671 7.08614 12.0007 7.30612 12.0919C7.5261 12.1831 7.76188 12.23 8 12.23C8.23812 12.23 8.4739 12.1831 8.69388 12.0919C8.91386 12.0007 9.11372 11.8671 9.28204 11.6987L11.222 9.75873C11.326 9.64369 11.3818 9.49306 11.3778 9.33802C11.3739 9.18298 11.3104 9.03541 11.2006 8.92587C11.0909 8.81632 10.9432 8.75318 10.7881 8.74953C10.6331 8.74588 10.4825 8.80199 10.3677 8.90625L8.59994 10.6746L8.60417 1.35417C8.60417 1.19393 8.54051 1.04026 8.42721 0.926956C8.31391 0.813653 8.16023 0.75 8 0.75C7.83977 0.75 7.68609 0.813653 7.57279 0.926956C7.45949 1.04026 7.39583 1.19393 7.39583 1.35417L7.3904 10.6632L5.63227 8.90625C5.5189 8.79296 5.36518 8.72935 5.20491 8.72941C5.04464 8.72947 4.89096 8.79319 4.77768 8.90655C4.66439 9.01992 4.60078 9.17364 4.60084 9.33391C4.60089 9.49418 4.66461 9.64786 4.77798 9.76115L6.71796 11.6987Z"
        fill="#151718"
      />
      <path
        d="M14.6458 10.4167C14.4856 10.4167 14.3319 10.4803 14.2186 10.5936C14.1053 10.7069 14.0417 10.8606 14.0417 11.0208V13.4375C14.0417 13.5977 13.978 13.7514 13.8647 13.8647C13.7514 13.978 13.5977 14.0417 13.4375 14.0417H2.5625C2.40227 14.0417 2.24859 13.978 2.13529 13.8647C2.02199 13.7514 1.95833 13.5977 1.95833 13.4375V11.0208C1.95833 10.8606 1.89468 10.7069 1.78138 10.5936C1.66807 10.4803 1.5144 10.4167 1.35417 10.4167C1.19393 10.4167 1.04026 10.4803 0.926956 10.5936C0.813653 10.7069 0.75 10.8606 0.75 11.0208V13.4375C0.75 13.9182 0.940959 14.3792 1.28087 14.7191C1.62078 15.059 2.0818 15.25 2.5625 15.25H13.4375C13.9182 15.25 14.3792 15.059 14.7191 14.7191C15.059 14.3792 15.25 13.9182 15.25 13.4375V11.0208C15.25 10.8606 15.1863 10.7069 15.073 10.5936C14.9597 10.4803 14.8061 10.4167 14.6458 10.4167Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_2788_20035">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DownloadIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default DownloadIcon;
